import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import Modal from "../../components/modal";
import * as Yup from "yup";
import { FormInput } from "../../wrappers/formInput";
import { Error } from "@progress/kendo-react-labels";
import Button from "../../components/button";
import UploadFiled from "../../components/fileduploader";
import RadioGroup from '../../components/radioGroup';
import * as CONSTANTS from '../../utils/CONSTANTS';
import FormHead from "../../components/headings/FromHead";
import { postAPI, uploadApi } from "../../api";
import { REACT_APP_CANDIDATE_FREELANCER } from "../../utils/common";

export type AddAwardsForm = {
  type: number;
  number: number;
  name: string;
  supportingDocument: string;
  logo: string;
};

interface Props {
  onClose?: any;
  clickHandler?: any;
  defaultValues?: any;
  customerId?: any;
}

const validationSchema = Yup.object({
  number: Yup.string().required("Field is Required").nullable(true),
  name: Yup.string().required("Field is Required"),
});

const AddAwards: React.FC<Props> = ({ onClose, clickHandler, defaultValues , customerId }) => {
  const formOptions = {
    resolver: yupResolver(validationSchema),
    defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues]),
  };

  const { register, handleSubmit, setValue, formState } =
    useForm<AddAwardsForm>(formOptions)

  const { v4: uuidv4 } = require("uuid");
  const [checkType, setCheckType] = useState<any>()
  const [errors, setErros] = useState<{ type?: string}>({ type: ""})

  useEffect(() => {
    
    if (defaultValues) {
      if(defaultValues.certificationId){
        setCheckType(1)
      }
      if(defaultValues.awardId){
        setCheckType(2)
      }
      setValue('name', defaultValues.awardName ? defaultValues.awardName : defaultValues.certificationName)
      setValue('number', defaultValues.awardNumber ? defaultValues.awardNumber : defaultValues.certificationNumber)
      setValue('logo',defaultValues.logo)
      setValue('supportingDocument', defaultValues.supportingDoc)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);
 

  const uploadFile = (e: any) => {
    let fileExtension = e.target.files[0].name.split(".").pop();
    if (fileExtension === "pdf" || fileExtension === "doc" || fileExtension === "docx") {
      let fileName = uuidv4() + e.target.files[0].name.replace(/ /g, "");
      let file = e.target.files[0]
      let type = file.type
    
      let value = {
        "action":"putObject",
        "filename":fileName
      }
    
      postAPI( REACT_APP_CANDIDATE_FREELANCER + '/resume-signed-url', value).then((data) => {    
        let signedUrl = data.url;    
        uploadApi(signedUrl, file, type).then((response) => {
          setValue('supportingDocument', fileName.slice(36, fileName.length))
        }
        )
      })
    }
  }

  const uploadLogo = (e: any) => {
    let fileExtension = e.target.files[0].name.split(".").pop();
    if (fileExtension === "png" || fileExtension === "jpeg" || fileExtension === "gif" || fileExtension === "jpg") { 
      let fileName = uuidv4() + e.target.files[0].name.replace(/ /g, "");
      let file = e.target.files[0]
      let type = file.type
    
      let value = {
        "action":"putObject",
        "filename":fileName
      }
    
      postAPI( REACT_APP_CANDIDATE_FREELANCER + '/resume-signed-url', value).then((data) => {    
        let signedUrl = data.url;    
        uploadApi(signedUrl, file, type).then((response) => {
          setValue('logo', fileName)
        }
        )
      })
    }
  }

  const submitValues = (data: any) => {
    
    if(!checkType){
      errors.type='Select atleast one option'
    }
    setErros({...errors})
    clickHandler(data)  
  }

  const handleChange = (e: any, name: string) => {    
    if ( name === 'type'){
      delete errors.type
      setValue('type', e.value)
      setCheckType(e.value)
    }
  }

  return (
    <div>
      <Modal title={"Add Awards/Certificates"} size="medium" onClose={onClose}>
      <form>
      <FormHead>Add Awards/Certificates</FormHead>
      <div className="form-group mb-40">
        <RadioGroup 
          data={CONSTANTS.AwardOrCertificate}
          layout="horizontal"
          handleChange={(e: any) => handleChange(e, 'type')}
          checked={checkType}
            />
            <br></br>
        <Error>{errors?.type}</Error>
      </div>
      <div className="half-form-wrap">
        <div className="form-group">
          <FormInput<AddAwardsForm>
            name="number"
            register={register}
            errors={formState.errors}
            label="Certification/Award Number*"
            placeholder="Enter certification/award number"
            type="text"
          />
        </div>
        <div className="form-group">
          <FormInput<AddAwardsForm>
            name="name"
            type="text"
            register={register}
            errors={formState.errors}
            label="Certification/Award Name*"
            placeholder="Enter certification/award name"
          />
        </div>
      </div>
        <div className="form-group">
          <label className="lablel">Certification/Award Logo</label>
          <div className="uploadWrap no-padd-dropzone">
            <FormInput<AddAwardsForm>
              id="logo"
              type="text"
              name="logo"
              placeholder="Upload documents"
              register={register}
              errors={formState.errors}
              disabled={true}
            />
            <UploadFiled uploadFile={uploadLogo} />
          </div>
        </div> 
        <div className="form-group">
          <label className="lablel">Upload supporting documents</label>
          <div className="uploadWrap no-padd-dropzone">
            <FormInput<AddAwardsForm>
              id="supportingDocument"
              type="text"
              name="supportingDocument"
              placeholder="Upload documents"
              register={register}
              errors={formState.errors}
              disabled={true}
            />
            <UploadFiled uploadFile={uploadFile} />
          </div>
        </div> 
        <div className="popupAction">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit(submitValues)}>
            Save
          </Button>
        </div>
      </form>
      </Modal>
    </div>
  );
};

export default AddAwards;
